<template>
  <div v-if="salesReady" id="sales">
     <section>
      <row>
        <column xl="3" md="6" class="mb-3">
          <card class="classic-admin-card primary-color">
            <card-body>
              <div class="pull-right white-text">
                <fa icon="money"/>
              </div>
              <p class="white-text">ПЛАН</p>
              <h4 class="white-text"><strong>€{{plantotal()}}</strong></h4>
            </card-body>
            </card>
        </column>
        <column xl="3" md="6" class="mb-3">
          <card class="classic-admin-card" v-bind:class="{'warning-color':salestotal()<plantotal(), 'success-color':salestotal()>plantotal()}">
            <card-body>
              <div class="pull-right white-text">
                <fa icon="line-chart"/>
              </div>
              <p class="white-text">ПРОДАЖИ</p>
              <h4 class="white-text"><strong>€{{salestotal()}}</strong></h4>
            </card-body>
          </card>
        </column>
        <column xl="3" md="6" class="mb-3">
          <card class="classic-admin-card primary-color">
            <card-body>
              <div class="pull-right white-text">
                <fa icon="bar-chart"/>
              </div>
              <p class="white-text">ПРИБЫЛЬ</p>
              <h4 class="white-text"><strong>€{{Math.round(profittotal())}}</strong></h4>
            </card-body>
           </card>
        </column>
        <column xl="3" md="6" class="mb-3">
          <card class="classic-admin-card primary-color">
            <card-body>
              <div class="pull-right white-text">
                <fa icon="pie-chart"/>
              </div>
              <p class="white-text">ПРИБЫЛЬ</p>
              <h4 class="white-text"><strong>{{Math.round(this.totalprofit/this.totalsales*100)}} % </strong></h4>
            </card-body>
            </card>
        </column>
      </row>
    </section>
     <!-- Catalog -->
      <div class="input-group md-form form-sm form-2 pl-0 mb-3">
         <div class="input-group-prepend">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-model.trim="search" type="text" placeholder="Поиск" aria-label="Search" title="Введи ключевые слова в поле поиска">
        <span class="input-group-text text-white red hoverable" title="Очистить поле ввода" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </div>
    <div class="card-group pb-1" v-for="(contragent, index) in filteredList" :key="index" :id=calculateid(contragent.Ref_Key)>
      <card  xl="4">
        <card-body>
         <card-title>
           <div class="input-group-prepend col pl-0 " style="cursor: pointer;">
             <div style="cursor: pointer;" class="hoverable input-group-text text-white mr-2" @click="$emit('infoContragent',contragent.Ref_Key)" v-bind:class="{'success-color':contragent.class === 'AX','success-color-dark':contragent.class === 'AY','default-color':contragent.class === 'AZ','info-color':contragent.class === 'BX','primary-color':contragent.class === 'BY','info-color-dark':contragent.class === 'BZ','warning-color':contragent.class === 'CX','warning-color-dark':contragent.class === 'CY','danger-color':contragent.class === 'CZ','elegant-color':contragent.class === 'UU'}" tag="a" title='Анализ клиента'> {{contragent.class}} {{contragent.sales}}
             </div>
             {{ contragent.Description}}
             </div>
           </card-title>
           <card-text>
            <badge title="План" style="font-size: 100%;cursor: pointer;" color="primary-color">{{plan(contragent)}}</badge>
            <badge title="Продажи" style="font-size: 100%;cursor: pointer;" v-bind:class="{'success-color':turnover(contragent.АналитикаУчетаПоПартнерам_Key)>=plan(contragent),'warning-color':turnover(contragent.АналитикаУчетаПоПартнерам_Key)<plan(contragent),'danger-color':turnover(contragent.АналитикаУчетаПоПартнерам_Key)===0}">{{turnover(contragent.АналитикаУчетаПоПартнерам_Key)}}</badge>
            <badge title="Прибыль" style="font-size: 100%;cursor: pointer;" color="info-color">{{Math.round(profit(contragent.АналитикаУчетаПоПартнерам_Key))}}</badge>
            <badge title="Прибыль %" style="font-size: 100%;cursor: pointer;" color="info-color">{{Math.round(profitPercent(contragent.АналитикаУчетаПоПартнерам_Key))}} % </badge>
            </card-text>
          {{contragent.БизнесРегион}}
          <div v-if="partnersPayments[contragent.Партнер_Key]!==undefined && partnersPayments[contragent.Партнер_Key]>0">
            <span class="badge badge-danger">{{ partnersPayments[contragent.Партнер_Key] }}</span>
         </div>
         </card-body>
        </card>
      <template v-if="selectedManager !== '00000000-0000-0000-0000-000000000000'">
        <card  xl="4" title="Продажи по неделям">
        <card-body>
           <div v-if="!hidechart" style="display: block">
             <bar-chart :data="barChartData(contragent)" :options="barChartOptions" :height="150"></bar-chart>
           </div>
        </card-body>
        </card>
        <card  xl="4">
        <card-body>
          <!-- Table  -->
  <tbl>
    <!-- Table head -->
    <!-- Table head -->

    <!-- Table body -->
    <tbl-body>
      <tr>
        <td><i class="fas fa-shopping-cart" v-bind:class="{'text-success':turnover(contragent.АналитикаУчетаПоПартнерам_Key) > plan(contragent), 'text-danger ':contragent.shortSales[0] === 0, 'text-warning':contragent.shortSales[0]>0 && turnover(contragent.АналитикаУчетаПоПартнерам_Key) < plan(contragent) }"></i></td>
        <td><i class="fas fa-shopping-cart" v-bind:class="{'text-success':contragent.shortSales[1] > 0}"></i></td>
        <td><i class="fas fa-shopping-cart" v-bind:class="{'text-success':contragent.shortSales[2] > 0}"></i></td>
        <td><i class="fas fa-shopping-cart" v-bind:class="{'text-success':contragent.shortSales[3] > 0}"></i></td>
      </tr>
      <tr>
        <td><i class="fas fa-child" v-bind:class="{'text-danger animated slow infinite tada':contragent.shortSales[0] + contragent.shortSales[1] + contragent.shortSales[2] + contragent.shortSales[3] === 0}"  title="Результаты встречи"></i></td>
        <td><i class="fas fa-child" title="Результаты встречи"></i></td>
        <td><i class="fas fa-child" title="Результаты встречи"></i></td>
        <td><i class="fas fa-child" title="Результаты встречи"></i></td>
      </tr>
      <tr>
        <td class="badge hoverable" @click="makeCall(contragent)"><i class="far fa-comments black-text" v-bind:class="{'text-warning animated slow infinite flip':turnover(contragent.АналитикаУчетаПоПартнерам_Key) < plan(contragent)}" title="Результаты разговора"></i></td>
        <td><i class="far fa-comments" v-bind:title="partnerCall(contragent.Партнер_Key,0)" v-bind:class="{'text-info' : partnerCall(contragent.Партнер_Key,0) !==''}"></i></td>
        <td><i class="far fa-comments" v-bind:title="partnerCall(contragent.Партнер_Key,1)" v-bind:class="{'text-info' : partnerCall(contragent.Партнер_Key,1) !==''}"></i></td>
        <td><i class="far fa-comments" v-bind:title="partnerCall(contragent.Партнер_Key,2)" v-bind:class="{'text-info' : partnerCall(contragent.Партнер_Key,2) !==''}"></i></td>
      </tr>
    </tbl-body>
    <!-- Table body -->
  </tbl>
  <!-- Table  -->
           </card-body>
        </card>
     </template>
    </div>
      <back-to-top bottom="30px" right="30px">
          <button @click="$refs.inp.focus()" type="button" class="btn  red darken-3 hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
      </back-to-top>
   <mdb-container>
        <mdb-row>
          <mdb-col size="12" class="text-center mb-5">
            <mdb-modal v-if="showModal" @close="showModal = false" cascade class="text-left">
              <mdb-modal-header class="primary-color white-text">
                <h4 class="title"> <i class="far fa-comments"> </i> Новый разговор</h4>
              </mdb-modal-header>
              <mdb-modal-body class="grey-text">
                <mdb-input v-model="contragentName" size="sm" label="Клиент" icon="user" group type="text" validate error="wrong" success="right"/>
                <mdb-input v-model="phone" size="sm" label="Телефон" icon="phone" group type="text" validate error="wrong" success="right"/>
                <mdb-input v-model="tag" size="sm" label="Тема" icon="tag" group type="text" validate error="wrong" success="right"/>
                <mdb-input v-model="message" size="sm" :rows="2" label="Содержание" icon="align-justify"/>
              </mdb-modal-body>
              <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="showModal = false">Отмена</mdb-btn>
                <mdb-btn @click.native="postConversation(), showModal = false" color="primary">Сохранить</mdb-btn>
              </mdb-modal-footer>
            </mdb-modal>
          </mdb-col>
        </mdb-row>
      </mdb-container>
  </div>
</template>

<script>
import { Row, Container, Column, Btn, Card, CardGroup, CardTitle, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Carousel, CarouselItem, CarouselCaption, Tbl, TblHead, TblBody, mdbContainer, mdbRow, mdbCol, mdbInput, mdbTextarea, mdbBtn, mdbIcon, mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter } from 'mdbvue'
import ApiService from '@/services/ApiService'
// import format from 'date-fns/format'
// import subDays from 'date-fns/sub_days'
// import addDays from 'date-fns/add_days'
import differenceInDays from 'date-fns/difference_in_days'
export default {
  name: 'sales',
  components: {
    Row,
    Column,
    Container,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardGroup,
    CardText,
    CardTitle,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Carousel,
    CarouselItem,
    CarouselCaption,
    Tbl,
    TblHead,
    TblBody,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter
  },
  props: ['authorized', 'acti', 'goods', 'orders', 'mng', 'rate', 'contragents', 'folder1', 'folder2', 'partnersABCXYZ', 'selectedManager', 'partnersSalesByPeriod', 'startDate', 'endDate', 'user', 'salesReady'],
  data () {
    return {
      showModal: false,
      contragentName: '',
      partnerKey: '',
      partnersPayments: {},
      partnersSales: [],
      phone: '',
      phoneCalls: [],
      tag: '',
      message: '',
      results: [],
      search: 'AX',
      hidechart: false,
      itemsSelected: 0,
      closetags: false,
      inlist: false,
      totalplan: 0,
      totalsales: 0,
      totalprofit: 0,
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  watch: {
    selectedManager () {
      // console.log('hide Chart')
      this.hidechart = true
      setTimeout(() => { this.updateChart() }, 10)
      // this.$data._chart.update()
    },
    search () {
      this.hidechart = true
      setTimeout(() => { this.updateChart() }, 10)
    },
    filteredList () {
      this.filteredList.forEach((el) => {
        this.getClientBalance(el.Партнер_Key)
      })
    }
  },
  mounted () {
    this.$bus.$on('selectedclass', (event) => {
      this.search = event
      console.log(event)
    })
    this.getPhoneCalls()
    // this.getPartnersPayments()
    // this.getPartnersSales()
    this.contragents.sort((a, b) => {
      if (a.sales < b.sales) {
        return 1
      }
      if (a.sales > b.sales) {
        return -1
      }
      // a должно быть равным b
      return 0
    })
    this.hidechart = true
    setTimeout(() => { this.updateChart() }, 1)
  },
  created () {
  },
  beforeDestroy () {
    console.log('destroy')
    this.$emit('salesDestroy')
    this.contragents.sort((a, b) => {
      if (a.Description > b.Description) {
        return 1
      }
      if (a.Description < b.Description) {
        return -1
      }
      // a должно быть равным b
      return 0
    })
  },
  computed: {
    filteredList () {
      // console.log(this.selectedManager)
      if (this.selectedManager === '00000000-0000-0000-0000-000000000000') {
        // console.log(this.selectedManager)
        return this.contragents.filter(contragent => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0) return true
          var res = true
          keywords.forEach((element, index) => {
            // console.log(good.НаименованиеПолное)
            var str = contragent.Description + ' ' + contragent.class + contragent.БизнесРегион
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false) res = false
          })
          return res
        })
      } else {
        return this.contragents.filter(contragent => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0 && contragent.ОсновнойМенеджер_Key === this.selectedManager) return true
          var res = true
          keywords.forEach((element, index) => {
            // console.log(good.НаименованиеПолное)
            var str = contragent.Description + ' ' + contragent.class + contragent.БизнесРегион
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true && contragent.ОсновнойМенеджер_Key === this.selectedManager) res = true
            if (res === false || res1 === false || contragent.ОсновнойМенеджер_Key !== this.selectedManager) res = false
          })
          return res
        })
      }
    },
    showpicture () {
      // console.log(this)
      return true
    }
  },
  methods: {
    partnerCall (partnerKey, shift) {
      var calls = []
      calls = this.phoneCalls.filter(call => call.АбонентКонтакт === partnerKey)
      // console.log(calls.length)
      if (calls.length > shift) return (this.$moment(calls[shift].Date).format('DD-MM-YYYY') + ': ' + calls[shift].Тема + ' - ' + calls[shift].Описание)
      else return ''
    },
    async makeCall (contragent) {
      this.contragentName = contragent.Description
      this.partnerKey = contragent.Партнер_Key
      const response = await ApiService.getPhone(this.partnerKey)
      let data = response.data.value
      this.phone = ''
      this.tag = ''
      this.message = ''
      if (data.length > 0) {
        data.forEach((phone) => {
          // console.log(phone.НомерТелефона)
          this.phone += phone.НомерТелефона + ' '
        })
      }
      // this.phone
      this.showModal = true
    },
    async postConversation () {
      console.log('partnerKey ' + this.partnerKey)
      let response = await ApiService.createConversation(this.partnerKey, this.contragentName, this.selectedManager, this.phone, this.tag, this.message)
      console.log(response.data)
      this.getPhoneCalls()
    },
    async getPhoneCalls () {
      console.log('getPhoneCalls')
      let response = await ApiService.getPhoneCalls()
      this.phoneCalls = response.data.value
    },
    async getClientBalance (partnerkey) {
      if (this.partnersPayments[partnerkey] === undefined) {
        console.log('Get client balance')
        const response = await ApiService.getClientBalance(partnerkey, '30')
        let data = response.data.value
        // console.log(data[0].Просрочено)
        if (data[0].Просрочено === undefined) this.partnersPayments[partnerkey] = 0
        else this.partnersPayments[partnerkey] = data[0].Просрочено
      }
    },
    updateChart () {
      this.hidechart = false
      console.log('update chart')
    },
    barChartData (contragent) {
      var bcd = {}
      bcd = {
        labels: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
        datasets: [
          {
            data: contragent.shortSales,
            backgroundColor: '#33b5e5',
            borderWidth: 1
          }
        ]
      }
      return bcd
    },
    plan (contragent) {
      var daysdiff = this.diffdays()
      if (daysdiff === 0) daysdiff = 1
      return Math.round(contragent.sales / 365 * daysdiff)
    },
    plantotal () {
      var sales = 0
      var daysdiff = this.diffdays()
      if (daysdiff === 0) daysdiff = 1
      this.filteredList.forEach((contragent) => {
        sales += contragent.sales
      })
      this.totalplan = Math.round(sales / 365 * daysdiff)
      return this.totalplan
    },
    salestotal () {
      var sales = 0
      this.filteredList.forEach((contragent) => {
        sales += this.turnover(contragent.АналитикаУчетаПоПартнерам_Key)
      })
      this.totalsales = Math.round(sales)
      return this.totalsales
    },
    partnerDebt (partneranakey) {
      var debt = 0
      var s = 0
      var p = 0
      var arr = this.partnersSales.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      if (arr.length > 0) {
        s = arr[0].СуммаВыручкиСНДСРеглTurnover
        console.log('s ' + s)
      }
      arr = this.partnersPayments.filter(payment => payment.АналитикаУчетаПоПартнерам_Key === partneranakey)
      if (arr.length > 0) {
        p = arr[0].СуммаReceipt
        console.log('p ' + p)
      }
      debt = s - p
      // console.log(debt)
      return debt
    },
    profittotal () {
      var sales = 0
      this.filteredList.forEach((contragent) => {
        sales += this.profit(contragent.АналитикаУчетаПоПартнерам_Key)
      })
      this.totalprofit = sales
      return this.totalprofit
    },
    diffdays () {
      // console.log(differenceInDays(this.endDate, this.startDate))
      return differenceInDays(this.endDate, this.startDate)
    },
    turnover (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result)
      if (result.length === 0) return 0
      else {
        var sum = 0
        result.forEach((el) => {
          sum += el.СуммаВыручкиБезНДСTurnover
        })
        return sum
      }
    },
    profit (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result.length)
      if (result.length === 0) return 0
      else {
        var sum = 0
        result.forEach((el) => {
          sum += (el.СуммаВыручкиБезНДСTurnover - el.СтоимостьБезНДСTurnover - el.ДопРасходыБезНДСTurnover)
        })
        return sum
      }
    },
    profitPercent (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result)
      if (result.length === 0) return 0
      else return 100 * (result[0].СуммаВыручкиБезНДСTurnover - result[0].СтоимостьБезНДСTurnover - result[0].ДопРасходыБезНДСTurnover) / result[0].СуммаВыручкиБезНДСTurnover
    },
    element (contragent) {
      return contragent.Ref_Key
    },
    calculateInput (good, event) {
      // console.log(event.target.value)
      if (event.target.value <= 0) {
        event.target.value = ''
        return ''
      } else {
        return event.target.value
      }
    },
    ChangeItem (good) {
      this.$emit('orderedItems')
    },
    calculateid (refkey) {
      return 'i' + refkey
    },
    transit (good) {
      return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
    },
    searchFocus (str) {
      this.showOnce = false
      this.$refs.inp.focus()
      // console.log(str)
      this.search += str
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto
    }
</style>



// WEBPACK FOOTER //
// src/components/Sales.vue